import { usePartner } from "../../context/PartnerContext";
import { useParams } from "react-router-dom";
import { getSessionFee, getStrikePrice } from "../../utils/pricing";

const OfferHighlight = ({ selectedCity }) => {
  const { config } = usePartner() || {};
  const { partnerSlug } = useParams();
  const displayPrice = getSessionFee({ partnerSlug, config });
  const strikePrice = getStrikePrice(displayPrice);

  void selectedCity;

  return (
    <div
      className="text-center py-3 text-white font-bold text-lg"
      style={{ backgroundColor: "var(--partner-primary)" }}
    >
      First Session for{" "}
      <span className="line-through text-sm mr-1">{"\u20B9"}{strikePrice}</span> {"\u20B9"}{displayPrice}
    </div>
  );
};

export default OfferHighlight;
